import axios from 'axios'

export default class Cargo {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/dominios/cargoUsuario`
    this.tokenBearer = tokenBearer
  }

  getCargos () {
    return new Promise(async (resolve, reject) => {
      let optionsCargos = {
        method: 'get',
        url: `${this.url}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseCargos = await axios(optionsCargos)
        resolve(responseCargos)
      } catch (err) {
        reject(err)
      }
    })
  }
}
